import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Floater from 'react-floater';
import { icons } from '../../../../assets';
import { Loader, LineChart } from '../../../../components';
import {
  getStatus,
  GetColor,
  notifyWarning,
  historicKey,
} from '../../../../utils';
import * as s from './styled-cards-supervisorios';

const Card = ({
  variavel,
  favorite,
  handleFavorite,
  saveRanges,
  thingId,
  thingName,
  selected,
  setSelected,
  handleAddRange,
  handleDeleteRange,
}) => {
  const [newRange, setNewRange] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingGraph, setLoadingGraph] = useState(true);
  const [open, setOpen] = useState(false);
  const [openList, setOpenList] = useState(false);
  const [animating, setAnimating] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState('daily');
  const [previousConfiguration, setPreviousConfiguration] = useState();
  const { values } = useSelector((state) => state.iot[thingName]);
  const { historic } = useSelector((state) => state);
  const { user } = useSelector((state) => state.usuario);
  const dispatch = useDispatch();

  useEffect(() => {
    orderRange(variavel.range);
  }, [loading, variavel, variavel.range]);

  useEffect(() => {
    if (selected === variavel.id) {
      setAnimating(true);
      setOpen(true);
      return undefined;
    }
    setAnimating(false);
    // setTimeout COM cleanup — antes nao retornava nada e o timer
    // continuava ativo apos unmount, gerando warning 'state update on
    // unmounted component' no console.
    const timer = setTimeout(() => {
      setOpen(false);
    }, 500);
    return () => clearTimeout(timer);
  }, [selected, variavel.id]);

  useEffect(() => {
    // Cache chaveado por thingId+variavel (historicKey) — sem isso o
    // grafico de uma variavel com mesmo ihmname em outra maquina
    // reaproveitava cache errado.
    const cacheKey = historicKey(thingId, variavel.ihmname);
    if (open && !historic[cacheKey]) {
      setLoadingGraph(true);
      dispatch({
        type: 'HISTORIC/FETCH_VARIABLE_HISTORIC',
        period: selectedPeriod,
        thing: thingName,
        variable: variavel.ihmname,
        thingId,
        variablesId: variavel.id,
      });
    } else if (open) {
      if(!historic[cacheKey][selectedPeriod]){
        setLoadingGraph(true);
        dispatch({
        type: 'HISTORIC/FETCH_VARIABLE_HISTORIC',
        period: selectedPeriod,
        thing: thingName,
        variable: variavel.ihmname,
        thingId,
        variablesId: variavel.id,
      });
      }else{
        setLoadingGraph(false);
      }
    } else if(open){
      setLoadingGraph(false);
    }
  }, [open, selectedPeriod, historic, dispatch, thingId, thingName, variavel.id, variavel.ihmname]);

  const orderRange = (ranges) => {
    setLoading(true);
    const objRange = {};
    ranges.forEach(({ category, level, min, max }) => {
      if (level)
        objRange[category] = {
          ...objRange[category],
          [level]: {
            min,
            max,
          },
        };
      else
        objRange[category] = {
          min,
          max,
        };
    });
    setNewRange(objRange);
    setLoading(false);
  };

  const FloaterAddRange = () => {
    let existNormal = false
    let currentRanges = variavel.range.map(
      ({ category, level }) => `${category}${level}`
    );

    currentRanges = [
      { value: 'EL', label: 'Atenção (low)' },
      { value: 'WL', label: 'Irregular (low)' },
      { value: 'N', label: 'Normal' },
      { value: 'WH', label: 'Irregular (high)' },
      { value: 'EH', label: 'Atenção (high)' },
    ].filter(({ value }) => !currentRanges.includes(value));

    variavel.range.map((rang) => {
      if(rang.category === 'N'){
      currentRanges.map((r, index2) => {
          if(r.value === 'N' || r.value === 'NAnull' || r.value === 'NA' || r.value === 'Nnull'){
            currentRanges.splice(index2, 1)
        }})
      }
    })

   currentRanges.map(r => {
     if(r.value === 'N' || r.value === 'NAnull' || r.value === 'NA' || r.value === 'Nnull'){ 
     existNormal = true 
    }})

    return (
      <Floater
        styles={{
          container: {
            padding: 0,
            minHeight: 0,
          },
        }}
        open={openList}
        content={
          <s.RangeListWrapper>
            {currentRanges.map((rang) => (
              <s.ItemList
                color={!existNormal || rang.value.slice(0, 1) === 'N'? "" : "disabled"}
                onClick={() => {if(!existNormal || rang.value.slice(0, 1) === 'N'){
                  const ranges = [...variavel.range, {level: rang.value.slice(1, 2),
                    category: rang.value.slice(0, 1), min: 0, max:0, unit: variavel.range[0].unit}]
                  if(rang.value.slice(0, 1) !== 'N'){
                    ranges.push({level: rang.value.slice(1, 2) === 'L' ? 'H' : 'L',
                      category: rang.value.slice(0, 1), min: 0, max:0, unit: variavel.range[0].unit})
                  }
                  handleAddRange(
                    variavel.id, ranges
                    // variavel.range[0].unit
                  );
                  if(previousConfiguration !== undefined){
                    if(previousConfiguration.idVariavel !== variavel.id){
                      setPreviousConfiguration({idVariavel: variavel.id, ranges: [...variavel.range]})
                    }
                  }else{
                    setPreviousConfiguration({idVariavel: variavel.id, ranges: [...variavel.range]})
                  }
                  setOpenList(false);
                }else{
                  notifyWarning('Adicione o range "normal" primeiro.')
                }
              }}
              >
                {rang.label}
              </s.ItemList>
            ))}
          </s.RangeListWrapper>
        }
        hideArrow
        offset={5}
      >
        <s.AddButton onClick={() => setOpenList(!openList)} />
      </Floater>
    );
  };
  if (!variavel.range || !variavel.range[0] || !variavel.range[0].category) {
    return <Loader />;
  }

  const currentValue = values[variavel.ihmname];
  const hasValue =
    currentValue !== false &&
    currentValue !== null &&
    currentValue !== undefined;
  const statusLabel = getStatus(variavel.status);
  const showStatus = hasValue && variavel.range[0].category !== 'NA';

  return (
    <>
      <s.Card
        key={variavel}
        selected={open}
        favorite={favorite}
        // Destaque por status: variavel em atencao/alarme ganha borda
        // lateral colorida pra "pular" no meio da parede de gauges (antes
        // tudo tinha o mesmo peso e um problema se perdia).
        $alert={
          !['normal', 'operando', 'sem dados', 'desligada'].includes(
            getStatus(variavel.status),
          )
        }
        $statusColor={GetColor(variavel.status, 'ranges')}
        grayed={
          !hasValue
        }
      >
        <s.Column selected={open}>
          <s.VariableRow>
            <s.FavoriteWrapper
              type="button"
              onClick={() => handleFavorite(variavel)}
              title={favorite ? 'Remover dos favoritos' : 'Adicionar aos favoritos'}
            >
              <img src={favorite ? icons.Star : icons.StarEmpty} alt="" />
            </s.FavoriteWrapper>
            <s.VariableIdentity>
              <s.Title>{variavel.name}</s.Title>
              <s.VariableCode>{variavel.ihmname}</s.VariableCode>
            </s.VariableIdentity>
            <s.ListValue color={GetColor(variavel.status, 'ranges')}>
              <span className="v">{hasValue ? String(currentValue) : '—'}</span>
              {hasValue && variavel.range[0].unit && (
                <span className="u">{variavel.range[0].unit}</span>
              )}
            </s.ListValue>
            <s.StatusCell>
              {showStatus ? (
                <s.Tag color={GetColor(variavel.status, 'ranges')}>
                  {statusLabel === 'normal' ? 'Normal' : statusLabel}
                </s.Tag>
              ) : (
                <s.NoData>Sem dados</s.NoData>
              )}
            </s.StatusCell>
            {user.role !== 'visualizador' && !open && (
              <s.ConfigSlot>
                <s.Button
                  disabled={!hasValue}
                  label="Configurar"
                  onClick={() => {
                    if (hasValue) {
                      setLoading(true);
                      setSelected(variavel.id);
                    }
                  }}
                />
              </s.ConfigSlot>
            )}
          </s.VariableRow>
          {open && !loading ? (
            <>
              <s.RangesWrapper className={animating ? 'fade-in' : 'fade-out'}>
                <div>{null}</div>
                <h3>MÍNIMO</h3>
                <h3>MÁXIMO</h3>
                <div>
                  {variavel.range.length < 5
                    ? FloaterAddRange(variavel.range)
                    : null}
                </div>
                {variavel.range
                  // .sort((a, b) => {
                  //   if (parseInt(a.min, 10) < parseInt(b.min, 10)) return -1;
                  //   return 1;
                  // })
                  .sort((a, b) => {
                    if ((a.category === "E" && a.level === "L") && (b.category === "W" && b.category === "L")) return -1;
                    return 1;
                  })
                  .sort((a) => {
                    if (a.category === "E" && a.level === "L" || a.category === "W" && a.level === "L") return -1;
                    return 1;
                  })
                  .sort((a, b) => {
                    if ((a.category === "W" && a.level === "H") && (b.category === "E" && b.level === "H")) return -1;
                    return 1;
                  })
                  .sort((a) => {
                    if (a.level === "L" && a.category === 'E') return -1;
                    return 1;
                  })
                  .sort((a, b) => {
                    if (a.category === "N" && b.level === 'H') return -1;
                    return 1;
                  })
                  .map((range) => (
                    <>
                      <s.RangeTitle color={GetColor(range.category, 'ranges')}>
                        {getStatus(range.category) === 'normal' ? 'normal' : getStatus(range.category) }
                        {range.level !== null && range.category !== 'N'
                          ? range.level === 'L'
                            ? ` (Low)`
                            : ` (High)`
                          : null}
                      </s.RangeTitle>
                      <s.Input
                        type="number"
                        onChange={(e) => {
                          const newNewRange = { ...newRange };
                          if (range.level)
                            newNewRange[range.category][range.level].min =
                              e.target.value;
                          else newNewRange[range.category].min = e.target.value;
                          setNewRange(newNewRange);
                        }}
                        // erro
                        value={
                          range.level && newRange[range.category]
                            ? newRange[range.category][range.level] &&
                              newRange[range.category][range.level].min
                            : newRange[range.category]
                            ? newRange[range.category].min
                            : ''
                        }
                      />
                      <s.Input
                        type="number"
                        onChange={(e) => {
                          const newNewRange = { ...newRange };
                          if (range.level)
                            newNewRange[range.category][range.level].max =
                              e.target.value;
                          else newNewRange[range.category].max = e.target.value;
                          setNewRange(newNewRange);
                        }}
                        value={
                          range.level && newRange[range.category]
                            ? newRange[range.category][range.level] &&
                              newRange[range.category][range.level].max
                            : newRange[range.category]
                            ? newRange[range.category].max
                            : ''
                        }
                      />
                      {getStatus(range.category) !== 'operando' 
                      && getStatus(range.category) !== 'sem dados' ? (
                        <s.DeleteButton
                          onClick={() =>{
                            handleDeleteRange(range, variavel.id)
                            if(previousConfiguration !== undefined){
                              if(previousConfiguration.idVariavel !== variavel.id){
                                setPreviousConfiguration({idVariavel: variavel.id, ranges: [...variavel.range]})
                              }
                            }else{
                              setPreviousConfiguration({idVariavel: variavel.id, ranges: [...variavel.range]})
                            }
                          }}
                        />
                      ) : (
                        <div>{null}</div>
                      )}
                    </>
                  ))}
              </s.RangesWrapper>
              <s.Line className={animating ? 'fade-in' : 'fade-out'}>
                <s.Button label="Cancelar" onClick={() => {
                  if(previousConfiguration)
                    handleAddRange(previousConfiguration.idVariavel, previousConfiguration.ranges)
                  setSelected(false)
                  }} />
                <s.Button
                  label="Salvar"
                  onClick={() =>
                    saveRanges(variavel.range, newRange, variavel.id)
                  }
                />
              </s.Line>
            </>
          ) : loading ? (
            <Loader />
          ) : null}
        </s.Column>

        {open && (
          <>
            {loadingGraph ? (
              <div
                style={{
                  width: 150,
                  height: 150,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Loader />
              </div>
            ) : (
              <s.GraficoWrapper
                id="history-graph-container"
                className={animating ? 'fade-in' : 'fade-out'}
              >
                <s.CloseButton onClick={() => setSelected('')} />
                <LineChart
                  selectedVar={variavel}
                  selectedPeriod={selectedPeriod}
                  setSelectedPeriod={setSelectedPeriod}
                  chartType="float"
                  things={[]}
                  thingId={thingId}
                />
              </s.GraficoWrapper>
            )}
          </>
        )}
      </s.Card>
    </>
  );
};

export default Card;
